<template>
  <v-row justify="center">
    <v-dialog
      v-model="dialog"
      persistent
      max-width="600px"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-spacer></v-spacer>
        <v-btn
          v-bind="attrs"
          color="success"
          v-on="on"
        >
          Ekle
        </v-btn>
      </template>
      <v-card>
        <v-card-title>
          <span class="text-h5">Banka Bilgisi Ekleme</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12">
                <input
                  id="image"
                  type="file"
                  name="image"
                  accept="image/*"
                />
              </v-col>

              <v-col cols="12">
                <v-text-field
                  label="Banka Adı"
                  required
                ></v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            text
            @click="dialog = false"
          >
            Close
          </v-btn>
          <v-btn
            color="blue darken-1"
            text
            @click="dialog = false"
          >
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>
<script>
export default {
  data: () => ({
    dialog: false,
  }),
}
</script>
